<div class="values">
  <div class="item" *ngFor="let asset of value">
    <div class="preview"><img [src]="asset.links?.thumb" alt="" /></div>
  </div>
</div>
